import { call, put } from 'redux-saga/effects';
import GetFileActions from '../redux/GetFileRedux';
import { api } from './api';


export function* getfilesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  const response = yield call(api.getFile, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetFileActions.getFileSuccess(response.data));
  } else {
    yield put(GetFileActions.getFileFailure());
  }
}